import SearchLanguagesFormContainer from 'components/SearchLanguagesForm/SearchLanguagesFormContainer'

export default {
  Container: SearchLanguagesFormContainer,
}
